import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Message } from 'semantic-ui-react'

class Toast extends Component {
  static propTypes = {
    toasts: PropTypes.array.isRequired
  }

  render () {
    const { toasts } = this.props
    return (
      toasts.map(toast => {
        return (
          <Message
            key={toast.id}
            {...toast.type}
            content={toast.message}
          />
        )
      })
    )
  }
}

export default Toast
